import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";
// import { ROLE_NAMES } from "../../../../util/constants";
import { ROLES } from "../../../../util/roleNameConstants";

export const fetchUsersList = async (setUsersList: any, toast: any) => {
  try {
    const response = await axios.get(
      `admin/user/list?page=-1&roleName=${encodeURIComponent(ROLES.HANDS_USER)}`
    );
    setUsersList(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchFormsList = async (setFormsList: any, toast: any) => {
  try {
    const response = await axios.get("health-and-safety/listOfSubModule");
    setFormsList(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchTeamsList = async (setTeamsList: any, toast: any) => {
  try {
    const response = await axios.get(`health-and-safety/get-list-of-teams`);
    setTeamsList(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const addFormMapping = async (
  selectedUser: any,
  setSelectedUser: any,
  selectedForms: any,
  setSelectedForms: any,
  selectedTeams: any,
  setSelectedTeam: any,
  isAreaManager: boolean,
  setIsAreaManager: any,
  setShow: any,
  setIsFormSubmitting: any,
  toast: any
) => {
  try {
    setIsFormSubmitting(true);

    const params: any = {};
    if (selectedUser && selectedUser.length > 0) {
      params.userIDs = selectedUser.map((user: any) => user.userID);
    }
    if (selectedForms && selectedForms.length > 0) {
      params.subModuleIDs = selectedForms.map((form: any) => form.id);
    }
    if (selectedTeams) {
      params.teamID = selectedTeams.id;
      params.isAreaManager = isAreaManager;
    }

    const response = await axios.post(
      "health-and-safety/add-hs-user-form",
      params
    );
    setShow(false);
    showSuccess(response.data.Message, toast);
    setSelectedUser(null);
    setSelectedForms(null);
    setSelectedTeam(null);
    setIsAreaManager(false);
    setIsFormSubmitting(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setIsFormSubmitting(false);
    showError(error, toast);
  }
};

export const updateFormMapping = async (
  formMappingID: number,
  selectedUser: any,
  setSelectedUser: any,
  selectedForms: any,
  setSelectedForms: any,
  selectedTeams: any,
  setSelectedTeam: any,
  isAreaManager: boolean,
  setIsAreaManager: any,
  setShow: any,
  setIsFormSubmitting: any,
  toast: any
) => {
  try {
    setIsFormSubmitting(true);

    if (!formMappingID) {
      showError("Form Mapping ID is required for update", toast);
      setIsFormSubmitting(false);
      return;
    }

    const params: any = {};
    if (formMappingID) {
      params.hsFormMenuID = formMappingID;
    }
    if (selectedUser && selectedUser.length > 0) {
      params.userIDs = selectedUser.map((user: any) => user.userID);
    }
    if (selectedForms && selectedForms.length > 0) {
      params.subModuleIDs = selectedForms.map((form: any) => form.id);
    }
    if (selectedTeams) {
      params.teamID = selectedTeams.id;
      params.isAreaManager = isAreaManager;
    }

    const response = await axios.post(
      `health-and-safety/edit-hs-user-form`,
      params
    );
    setShow(false);
    showSuccess(response.data.Message, toast);
    setSelectedUser(null);
    setSelectedForms(null);
    setSelectedTeam(null);
    setIsAreaManager(false);
    setIsFormSubmitting(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setIsFormSubmitting(false);
    showError(error, toast);
  }
};

export const deleteFormMapping = async (
  formMappingID: number,
  setFormMappingListingData: any,
  setFormMappingListingDataLoading: any,
  setIsConfirmDeleteDialogOpen: any,
  setIsDeleting: any,
  filters: any,
  toast: any,
  deleteReason: string
) => {
  try {
    setIsDeleting(true);
    if (!formMappingID) {
      showError("Form Mapping ID is required for deletion", toast);
      return;
    }
    const response = await axios.post(
      `health-and-safety/delete-hs-user-form?hsFormMenuID=${formMappingID}&userID=`,
      { statusChangeReason: deleteReason }
    );
    showSuccess(response.data.Message, toast);
    fetchFormMappingList(
      setFormMappingListingData,
      setFormMappingListingDataLoading,
      filters,
      toast
    );
    setIsConfirmDeleteDialogOpen(false);
    setIsDeleting(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setIsDeleting(false);
    showError(error, toast);
  }
};

export const fetchFormMappingList = async (
  setFormMappingListingData: any,
  setFormMappingListingDataLoading: any,
  filters: any,
  toast: any
) => {
  try {
    setFormMappingListingDataLoading(true);
    const params: any = {};
    if (filters?.user) {
      params.userIDs = filters.user.map((user: any) => user?.userID).join(",");
    }
    const response = await axios.get("health-and-safety/list-of-hs-user-form", {
      params,
    });
    setFormMappingListingData(response.data.result);
    setFormMappingListingDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setFormMappingListingDataLoading(false);
    showError(error, toast);
  }
};
